import styled from 'styled-components';
import Lab010 from 'dc/Lab010';

export const Wrapper = styled.div``;

export const Label = styled(Lab010)`
  > i {
    color: ${props => (props.color ? props.color : '#00ab97')};
    padding: ${props => (props.noPadding ? 0 : null)};
  }
  > span {
    color: #263238 !important;
  }
  margin-right: 12px;
`;

export const LoggedLabel = styled(Lab010)`
  > i {
    color: #00ab97;
  }
`;
